/**
 * THE WORK — the first thing on the tech's job screen (2026-10-15).
 *
 * The office's on-site brief (jobs.summary). On a job made from a quote it is
 * one plain line per device, written from the quote: what device, what to do,
 * what parts to grab — `Repair 3/4" Watts 009M3 SN: 123466 with complete
 * rebuild kit, and test after repair.` Big and plain: just the lines, nothing
 * else. It used to be small print in the reference column under the notes,
 * and newer notes buried it.
 *
 * Opaque surface: the BlueprintBackdrop watermark renders behind everything,
 * so a translucent card washes out (AGENTS.md frontend rule).
 */
import { scopeLines } from "@/lib/scope-lines";
import { cn } from "@/lib/utils";

export function ScopeLinesCard({ summary }: { summary: string | null | undefined }) {
    const lines = scopeLines(summary);
    if (lines.length === 0) return null;
    // Short scopes (the quote's device lines) read big; a long office brief
    // stays plain but a size down so it doesn't take the whole screen.
    const short = lines.length <= 4 && lines.every((l) => l.length <= 180);
    return (
        <section
            aria-label="The work"
            data-testid="scope-lines"
            className="rounded-xl border-2 border-primary/50 bg-card p-4 shadow-sm"
        >
            <div className="space-y-2">
                {lines.map((l, i) => (
                    <p
                        key={i}
                        className={cn(
                            "text-foreground",
                            short ? "text-xl font-semibold leading-snug" : "text-base leading-snug",
                        )}
                    >
                        {l}
                    </p>
                ))}
            </div>
        </section>
    );
}
